import { ReactNode, useMemo } from "react";
import { useGetFeatureFlagList } from "@modules/eirCustomersFacade/swr";
import { IFeatureFlagContext } from "@common/FeatureFlagProvider/IFeatureFlagContext";
import { FeatureFlagContext } from "@context/FeatureFlagContext";
import { TFeatureFlag } from "@common/FeatureFlag/TFeatureFlag";

interface IParams {
    isKeycloakReady: boolean;
    children: ReactNode;
}

export const FeatureFlagProvider = (props: IParams) => {
    const { isKeycloakReady, children } = props;

    const { data: featureFlagList } = useGetFeatureFlagList(isKeycloakReady);

    const contextValue: IFeatureFlagContext = useMemo(
        () => ({
            getIsFeatureEnabled: (featureName: TFeatureFlag): boolean =>
                featureFlagList?.find((featureFlag) => featureFlag.featureName === featureName)?.isEnabled ?? false,
        }),
        [featureFlagList]
    );

    return <FeatureFlagContext.Provider value={contextValue}>{children}</FeatureFlagContext.Provider>;
};
